<template>
  <div class="search-box">
    <div class="search-tip">
      <p>{{ $t("comprehensiveInquiry") }}</p>
      <p @click="isOpen = !isOpen">
        {{ $t("advancedSearch") }}<i :class="isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </p>
    </div>
    <div class="form-box">
      <el-form label-width="170px" :model="searchForm" label-suffix=":">
        <el-row>
          <el-col :span="isOpen ? 8 : 7">
            <el-form-item :label="$t('productName')">
              <el-input size="small" v-model="searchForm.pr_Na" :placeholder="$t('inputPlaceholder')"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isOpen ? 8 : 7">
            <el-form-item :label="$hs('产品净重', 'Product Weight', 'Poids net du produit')">
              <el-input size="small" v-model="searchForm.ne_We_Pr" :placeholder="$t('inputPlaceholder')"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isOpen ? 8 : 7">
            <el-form-item :label="$t('classify')">
              <el-cascader
                v-if="isPan"
                v-model="searchForm.cl_Nu"
                :options="getMenusList"
                ref="cascaderRef"
                :label-click="true"
                popper-class="category"
                clearable
                :props="{
                  expandTrigger: 'hover',
                  label: language == 'en' ? 'cl_Ne_Na' : language == 'fr' ? 'threeLanguage' : 'cl_Na',
                  value: 'cl_Nu',
                  checkStrictly: true,
                  checkOnClickNode: true,
                  showCheckbox: false,
                }"
              >
                <template #default="{ node, data }">
                  <div class="dataclNa" @click="handleChange(node, data)">
                    {{ $hs(data.cl_Na, data.cl_Ne_Na, data.threeLanguage) }}
                  </div>
                </template></el-cascader
              >
              <!-- <el-select
                style="width: 175px"
                v-model="searchForm.cl_Nu"
                clearable
                filterable
                :placeholder="$t('selectPlaceholder')"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item[$hs('cl_Na', 'cl_Ne_Na', 'threeLanguage')]"
                  :value="item.cl_Nu"
                  >{{ item[$hs("cl_Na", "cl_Ne_Na", "threeLanguage")] }}</el-option
                >
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="3" class="btn-search" v-if="!isOpen">
            <el-button type="primary" size="small" icon="el-icon-search" @click="search" v-show="!isOpen">{{
              $t("search")
            }}</el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div class="advanced-search" v-show="isOpen">
            <!-- <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('productSize')">
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.pr_Le"
                      :placeholder="$t('L')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.pr_Wi"
                      :placeholder="$t('W')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.pr_Hi"
                      :placeholder="$t('H')"
                    ></el-input>
                  </el-col>
                  <el-col class="tip" :span="4">CM</el-col>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cartonSize')">
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.ou_Le"
                      :placeholder="$t('L')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.ou_Wi"
                      :placeholder="$t('W')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.ou_Hi"
                      :placeholder="$t('H')"
                    ></el-input>
                  </el-col>
                  <el-col class="tip" :span="4">CM</el-col>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('packageSize')">
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.in_Le"
                      :placeholder="$t('L')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.in_Wi"
                      :placeholder="$t('W')"
                    ></el-input>
                  </el-col>
                  <el-col class="line" :span="1">-</el-col>
                  <el-col :span="6">
                    <el-input
                      size="small"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="searchForm.in_Hi"
                      :placeholder="$t('H')"
                    ></el-input>
                  </el-col>
                  <el-col class="tip" :span="4">CM</el-col>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('packingCapacity')">
                  <el-input
                    size="small"
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    v-model="searchForm.ou_Lo"
                    :placeholder="$t('inputPlaceholder')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="actionList">
                  <el-button size="small" type="info" plain @click="reset">{{ $t("reset") }} </el-button>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">{{
                    $t("search")
                  }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      isOpen: false,
      packList: [],
      options: [],
      isPan: true,
      searchForm: {
        pr_Na: "",
        co_Nu: "",
        pa_Nu: "",
        pr_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        ou_Hi: "",
        ou_Le: "",
        ou_Wi: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        ou_Lo: "",
        cl_Nu: [],
        ne_We_Pr: "",
      },
    };
  },
  computed: {
    ...mapState("operate", ["language"]),
    ...mapGetters("setting", {
      getMenus: "get_menus",
    }),
    getMenusList() {
      return this.filterEmptyChildren(this.getMenus);
    },
  },
  watch: {
    language: {
      handler(newVal) {
        this.isPan = false;

            this.$nextTick(() => {
        this.isPan = true;
            
        });
      },
      deep: true, // 数组必须开启深度监听
      immediate: true, // 进入页面立即执行一次
    },
  },
  methods: {
    filterEmptyChildren(treeList) {
      return treeList.map((item) => {
        // 先浅拷贝对象，避免修改原数据
        const newItem = { ...item };
        if (newItem.children && Array.isArray(newItem.children)) {
          if (newItem.children.length > 0) {
            // 子级有数据，继续递归处理子节点
            newItem.children = this.filterEmptyChildren(newItem.children);
          } else {
            // children为空数组，直接删除该字段
            delete newItem.children;
          }
        }
        return newItem;
      });
    },
    // 搜索
    search() {
      const conditionals = [];
      let formdata = { ...this.searchForm, cl_Nu: this.searchForm["cl_Nu"].at(-1) };
      if(formdata['cl_Nu'] === undefined) formdata['cl_Nu'] = ''
      Object.keys(formdata).forEach((item) => {
        // 样品名称和出厂货号
        if (formdata[item] !== "" && (item === "pr_Na" || item === "co_Nu")) {
          conditionals.push({
            conditionalType: 1, // 1为模糊搜索
            fieldName: item,
            fieldValue: formdata[item],
          });
          return;
        }
        // 其他字段构建复杂搜索条件
        if (formdata[item] !== "") {
          conditionals.push({
            conditionalType: 0, // 0为精确搜索
            fieldName: item,
            fieldValue: formdata[item],
          });
        }
      });

      this.$emit("search", conditionals);
    },
    handleChange(node, data) {
      console.log(data);
      let obj = this.getMenus.find((op) => op.cl_Nu == data.parent);
      this.searchForm.cl_Nu = obj ? [obj.cl_Nu, data.cl_Nu] : [data.cl_Nu];
      this.$nextTick(() => {
        this.$refs.cascaderRef.toggleDropDownVisible(false);
      });
    },
    // 重置表单
    reset() {
      this.searchForm = {
        pr_Na: "",
        co_Nu: "",
        pa_Nu: "",
        pr_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        ou_Hi: "",
        ou_Le: "",
        ou_Wi: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        ou_Lo: "",
        cl_Nu: "",
        ne_We_Pr: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  color: #333;
  font-size: 14px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;

  & .search-tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .form-box {
    padding-top: 20px;

    & .select-block {
      width: 100%;
    }

    & .btn-search {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      & .el-button {
        font-size: 14px;
      }
    }

    & .line {
      text-align: center;
    }

    & .tip {
      text-align: center;
      font-size: 12px;
    }

    .actionList {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;

      & .el-button {
        width: 120px;
        margin: 0 10px;
        font-size: 14px;
      }
    }
  }
}
</style>
